export const NAV_SECTION_IDS = {
  Primary: 'primary',
  Modules: 'modules',
  Footer: 'footer',
} as const;

export const NAV_IDS = {
  Settings: 'settings',
  GetStarted: 'get-started',
  Home: 'home',
  Actions: 'actions',
  Agents: 'agents',

  People: 'people',
  Productivity: 'productivity',
  Learning: 'learning',
  Engagement: 'engagement',
  Analytics: 'analytics',

  PeoplePulse: 'people-pulse',
  OrgStructure: 'org-structure',
  Employees: 'employees',

  ProductivityPulse: 'productivity-pulse',
  Mgsa: 'mgsa',
  Okrs: 'okrs',
  Cycles: 'cycles',
  Reviews: 'reviews',
  Tasks: 'tasks',
  Habits: 'habits',

  LearningPulse: 'learning-pulse',
  Library: 'library',
  Bookmark: 'bookmark',
  AllContent: 'all-content',
  MyRecents: 'my-recents',
  Collections: 'collections',
  QuestionBank: 'question-bank',
  Sessions: 'sessions',
  Assignment: 'assignment',
  Journeys: 'journeys',

  Surveys: 'surveys',
  Community: 'community',
  Meetings: 'meetings',
  OneOnOne: 'one-on-one',
  Praise: 'praise',
  Feedback: 'feedback',
} as const;

export const NAV_GROUP_IDS = {
  PeopleMain: 'people-main',
  ProductivityOverview: 'productivity-overview',
  ProductivityOkrs: 'productivity-okrs',
  ProductivityPerform: 'productivity-perform',
  LearningOverview: 'learning-overview',
  LearningContent: 'learning-content',
  LearningDelivery: 'learning-delivery',
  EngagementMain: 'engagement-main',
} as const;
